import { OrganizationBaseTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { OrganizationBaseType } from '@/services/graphql/types';

export const mapperOrganizationBaseTypeDataEnum = createEnumMapperFunction(
  OrganizationBaseType,
  OrganizationBaseTypeDataEnum
);
